module.exports = __webpack_public_path__ + "static/media/biocertica-logo-with-text-default-vertical.c9e1218c.svg";